import { render } from "./EditReflectionView.vue?vue&type=template&id=74dc4d64"
import script from "./EditReflectionView.vue?vue&type=script&lang=js"
export * from "./EditReflectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__